/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var MathSumIcon32Regular = forwardRef('MathSumIcon32Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 32 }, props),
        React.createElement("path", { d: "M6.846 8.25C5.117 6.813 6.132 4.001 8.38 4.001H25a1 1 0 0 1 0 2H8.38a.4.4 0 0 0-.256.708l8.968 7.443a2.4 2.4 0 0 1 0 3.694L8.123 25.29a.4.4 0 0 0 .256.708H25a1 1 0 0 1 0 2H8.38c-2.247 0-3.262-2.812-1.533-4.247l8.968-7.443a.4.4 0 0 0 0-.616L6.846 8.25Z" })));
});
